import { List, Map, fromJS } from 'immutable';
import * as constAction from 'root/actionConstants';

import { listFindByMapId } from 'core/generalFunctions';

var defaultState = Map({
  lista: List(),
  parada: Map(),
  rutinas: List(),
  eliminarId: false,
  paradasSugeridas: List()
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case constAction.PARADAS_CLEAR: {
      if (action.payload === 'all') return defaultState;
      else if (defaultState.has(action.payload))
        return state.set(action.payload, defaultState.get(action.payload));
      else {
        console.error('No existe la propiedad ' + action.payload);
        return state;
      }
    }
    case constAction.PARADAS_SET_STATE: {
      let newState = state;
      for (var key in action.payload) {
        newState = newState.set(key, fromJS(action.payload[key]));
      }
      return newState;
    }

    case constAction.PARADAS_ADD_MARKER: {
      return state.setIn(['parada', 'localizacion'], fromJS(action.payload));
    }

    case constAction.PARADAS_ACTUALIZAR_STATE: {
      let newState = state.get('lista') ? state.get('lista') : List(),
        index = listFindByMapId(newState, action.payload.id, true);
      newState = index === -1
        ? newState.push(fromJS(action.payload))
        : newState.set(index, fromJS(action.payload));
      return state.set('lista', newState);
    }
    case constAction.PARADAS_DELETE: {
      let index = listFindByMapId(state.get('lista'), action.payload, true);
      if (index == -1) return state;
      return state.deleteIn(['lista', index]);
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/modules/paradas/reducer.js